import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getAuditConfigurationType from '../../services/dossier/get/getAuditConfigurationType.js'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchAuditConfigurationType () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const auditConfigurationType = yield call(getAuditConfigurationType, auth.token)
    yield put(fetchCombosSuccess({ auditConfigurationType }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchAuditConfigurationType () {
  yield takeLatest(combosActionTypes.FETCH_AUDIT_CONFIGURATION_TYPE, fetchAuditConfigurationType)
}
